import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { CustomerContract } from "src/app/models/customer-contract.model";
import { Customer } from "src/app/models/customer.model";
import { NutsTypeEnum } from "src/app/models/enums/nutstype.enum";
import { ContractService } from "src/app/services/contract.service";
import { CustomerService } from "src/app/services/customer.service";

@Component({
    selector: 'contracts-component',
    standalone: true,
    templateUrl: './contracts.component.html',
    styleUrls: ['./contracts.component.scss'],
    imports: [ButtonModule, CommonModule, FormsModule, InputTextModule, RouterModule, SelectModule, TableModule],
    providers: [CustomerService, ContractService],
})
export class ContractsComponent {
    @Input() showButton: boolean = false;
    @Input() showExplanation: boolean = false;
    Customer = Customer;
    NutsTypeEnum = NutsTypeEnum;
    contracts: CustomerContract[] = [];
    contractTypes: string[] = ['Elektriciteit', 'Gas'];
    newContract: CustomerContract = new CustomerContract('', NutsTypeEnum.Elektriciteit, '');
    constructor(customerService: CustomerService, contractService: ContractService) {
        contractService.getContracts().subscribe(contracts => {
            this.contracts = contracts;
        });
    }
}